import { useState } from 'react';

interface Props<T> {
  value?: T;
  defaultValue?: T;
  onChange?: (value: T) => void;
}

export function useMergeState<T>({ defaultValue, value, onChange }: Props<T>) {
  const [innerValue, setInnerValue] = useState(() => {
    if (value === undefined) {
      return defaultValue;
    }

    return value ?? defaultValue;
  });

  const mergedValue = value !== undefined ? value : innerValue;

  const onValueChange = (changedValue: T) => {
    if (value === undefined) {
      setInnerValue(changedValue);
    }

    onChange?.(changedValue);
  };

  return {
    onChange: onValueChange,
    value: mergedValue,
  };
}
